<div class ='aar-domo-report aar-page'>
  <div class='content'>
    <div layout="column" layout-align="center center" layout-fill="layout-fill" ng-controller="testController">
      <iframe src="https://aarcorp.domo.com/embed/pages/private/bo3lX" width="1248" height="1620" marginheight="0" marginwidth="0" frameborder="0"></iframe>
    </div> 
  </div>
</div>